import Head from 'next/head';

import PageMargins from '@/components/ui/PageMargins/PageMargins';
import PageTopMarginWrapper from '@/components/ui/PageTopMarginWrapper/PageTopMarginWrapper';
import SectionHeader from '@/components/ui/SectionHeader/SectionHeader';
import useFormatMessage from '@/hooks/useFormatMessage';
import DefaultLayout from '@/layouts/default';

const CookieNoticePage = () => {
  const formatMessage = useFormatMessage();

  const pageTitle = formatMessage('cookie_notice_headline');

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta
          key="description"
          name="description"
          content={formatMessage('cookie_notice_description')}
        />
      </Head>
      <PageTopMarginWrapper>
        <PageMargins style={{ margin: '32px auto' }}>
          <SectionHeader>{pageTitle}</SectionHeader>

          <div className="cookie-button">
            <button id="ot-sdk-btn" className="ot-sdk-show-settings">
              Cookie Settings
            </button>
          </div>

          <div style={{ marginBottom: '30px' }} />

          <div id="ot-sdk-cookie-policy" />
        </PageMargins>
      </PageTopMarginWrapper>
    </>
  );
};

CookieNoticePage.getLayout = function getLayout(page) {
  return <DefaultLayout>{page}</DefaultLayout>;
};

export default CookieNoticePage;
